import { useState, useEffect } from "react";
import {  loadVendorQuoteComparisonList } from "../services/vendorEnquiryService";

const useVendorQuoteComparisonList = (Mode) => {
    const [vendorQuoteComparisonList, setVendorQuoteComparisonList] = useState([]);
    const [selectPurchasedIndent, setSelectPurchasedIndent] = useState(null);
    const [selectPurchasedIndentID, setSelectPurchasedIndentID] = useState(null);
    const [isVendorQuoteComparisonDataLoaded, setIsVendorQuoteComparisonDataLoaded] = useState(false);

    // Fetch department data
    const fetchVendorQuoteComparison = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };

        try {
            const data = await loadVendorQuoteComparisonList(para);
            if (data && data.length > 0) {
                setVendorQuoteComparisonList(data);
                setIsVendorQuoteComparisonDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isVendorQuoteComparisonDataLoaded) {
            fetchVendorQuoteComparison();
        }
    }, [isVendorQuoteComparisonDataLoaded]);

    // Function to load department based on selected ID
    const loadVendorQuoteComparisonByID = async (selectedID) => {
        await fetchVendorQuoteComparison(selectedID);
    };

    return {
        vendorQuoteComparisonList,
        setVendorQuoteComparisonList,
        selectPurchasedIndent,
        selectPurchasedIndentID,
        loadVendorQuoteComparisonByID,
    };
};

export default useVendorQuoteComparisonList;
